import { Action, ActionReducerMap, createReducer, on, props } from '@ngrx/store';
import { AppUserState } from '../_models/app.models';
import * as actions from './../_reducers/app.actions';

export const initialState: AppUserState = {
    nickname: null,
    username: null,
    password: null
};

/// lista de estados Globales de la aplicacion
export interface AppStates {
    userAppState: AppUserState;
};

export const appReducer: ActionReducerMap<AppStates> = {
    userAppState: userAppReducer
};


//////////////////////////////////////////

const _userReducer = createReducer(
  initialState,
  on(actions.setUserState, (state , {nickname , username, password}) => ({ ...state, nickname , username, password})),
  on(actions.reset, (state) => ({ nickname: null, username: null , password: null}))
);

export function userAppReducer(state, action) {
    return  _userReducer(state, action);
}

/// /////////////////////////////////////
